export class LocationMappingRmRackPostionReq {
    plantId:number
    brandId:number
    constructor(plantId:number,brandId:number) {
        this.plantId = plantId;
        this.brandId = brandId;
    }
}